import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getCurrentWebsiteCountry } from "@MasterBluePrint/Services/CurrentWebsiteCountryService";

addToChainAfter(chain, RequestDataFromApi, async props => {
    await getCurrentWebsiteCountry().then(response =>{
        props.apiResult.products?.forEach(product =>{
            product.currentWebsiteCountry = response;
        });
    });
});
